import { AppInner, ErrorPage } from '@retainerclub/common';
import { MainLayout } from '@retainerclub/customer-shared';
import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from 'react-router';
import { LocationProvider } from './shared/Context';
import Locator from './views/Locator/Locator';

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

function App() {
  const [cookies, setCookie] = useCookies(['rcGeo']);
  const [locationData, setLocationData] = useState({});
  const [shouldRefresh, setShouldRefresh] = useState(false);

  useEffect(() => {
    const id = setTimeout(
      () => setShouldRefresh(true),
      1000 * 60 * 60 * 6, // 6 hours in milliseconds
    );

    return () => clearTimeout(id);
  }, []);

  useEffect(() => {
    if (shouldRefresh) {
      window.location.reload(true);
    }
  }, [shouldRefresh]);

  useEffect(() => {
    const { rcGeo } = cookies;

    if (!rcGeo) {
      fetch(
        `https://ipapi.co/json/?key=${import.meta.env.VITE_IPAPI_API_KEY}`,
        {
          method: 'GET',
        },
      )
        .then((response) => response.json())
        .then((data) => {
          const locData = {
            address: null,
            city: data.city,
            region: data.region,
            postal: data.postal,
            lat: data.latitude,
            lng: data.longitude,
            country: data.country,
            formattedAddress: null,
          };

          setCookie('rcGeo', locData, {
            path: '/',
            maxAge: 3600 * 24 * 365,
          });

          setLocationData(locData);
        })
        .catch((error) => {
          console.error('ipapi error', error);
        });
    }

    if (rcGeo) {
      setLocationData(rcGeo);
    }
  }, [cookies, setCookie]);

  const router = sentryCreateBrowserRouter(
    createRoutesFromElements(
      <Route element={<AppInner />} errorElement={<ErrorPage />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Locator />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>,
    ),
  );

  return (
    <LocationProvider
      value={{
        locationData,
        setLocationData,
      }}
    >
      <RouterProvider router={router} />
    </LocationProvider>
  );
}

export default App;
